import React from "react";
import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";
import { buttonVariants } from "@/components/ui/button";
import usePathname from "@/hooks/use-pathname.tsx";
import {useTranslation} from "react-i18next";

interface SidebarNavProps extends React.HTMLAttributes<HTMLElement> {
  items: {
    href: string;
    title: string;
  }[];
}

export function SidebarNav({ className, items, ...props }: SidebarNavProps) {
  const {t} = useTranslation();
  const pathname = usePathname();

  return (
    <nav
      className={cn(
        "flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-1",
        className,
      )}
      {...props}
    >
      {items.map((item) => (
        <Link
          key={item.href}
          to={item.href}
          className={cn(
            buttonVariants({ variant: "ghost" }),
            "justify-start pl-3 text-text-2 hover:text-text-1",
            pathname === item.href
              ? "font-semibold text-text-1 bg-accent/5 hover:bg-accent/10 underline"
              : "hover:underline",
          )}
        >
          {pathname.startsWith("/match-criteria")
              ? t(`criteria.${item.title}`)
              : t(`sideNavbar.${item.title}`)
          }
        </Link>
      ))}
    </nav>
  );
}
